import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import { compactTourButtonSx } from './compactTourButton';

/** Icon-only replay control for workflow stage tours. */
export const StageTourButton = ({ sx, ...props }: Omit<ButtonProps, 'children' | 'startIcon'>) => (
  <Tooltip title="Take a tour" describeChild>
    <Button
      {...props}
      aria-label="Take a tour"
      variant="outlined"
      size="small"
      sx={[
        // Pseudo-element offsets are measured inside the 1px button border.
        { ...compactTourButtonSx, minWidth: 32, width: 32, px: 0, mx: '6px', '&::before': { ...compactTourButtonSx['&::before'], top: -3, bottom: -11, left: -7, right: -7 } },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <LightbulbOutlinedIcon fontSize="small" />
    </Button>
  </Tooltip>
);
